import Input from "../../../Medicine-master/Component/Input";

export const locationInput = [
  {
    tag: Input,
    img: "",
    label: "Phone 1",
    name: "phone",
    validation: "required",
    required: true,
    key: "phone",
  },
  {
    tag: Input,
    img: "",
    label: "Email",
    name: "email",
    validation: "required",
    key: "email",
  },
  {
    tag: Input,
    img: "",
    label: "Password",
    name: "password",
    validation: "required",
    key: "password",
  },
  // {
  //   tag: "multi",
  //   img: "",
  //   label: "Address",
  //   name: "address",
  //   validation: "required",
  //   key: "address",
  //   options: [
  //     { value: "option1", label: "Option 1" },
  //     { value: "option2", label: "Option 2" },
  //     { value: "option3", label: "Option 3" },
  //     // Add more options as needed
  //   ],
  // },
  
  {
    tag: Input,
    img: "",
    label: "Address",
    name: "address",
    validation: "required",
    key: "address",
  },
  {
    tag: Input,
    img: "",
    label: "PIN Code",
    name: "pincode",
    validation: "required",
    key: "pincode",
  },
  {
    tag: Input,
    img: "",
    label: "City",
    name: "city",
    validation: "required",
    key: "city",
  },
  {
    tag: Input,
    img: "",
    label: "State",
    name: "state",
    validation: "required",
    key: "state",
  },
  {
    tag: Input,
    img: "",
    label: "Country",
    name: "country",
    validation: "required",
    key: "country",
  },
  {
    tag: Input,
    img: "",
    label: "Headquaters",
    name: "headquarters",
    key: "headquarters",
  },
];
